<template>
  <CourierComponent />
</template>
<script lang="ts">
import CourierComponent from "@/components/courier/Courier.vue";
import { defineComponent } from "vue";
const componentName = "CourierRoute";
export default defineComponent({
  name: componentName,
  components: {
    CourierComponent,
  },
  props: {
    activationCodeToInstall: {
      type: String,
      required: false,
      default: null,
    },
  },
});
</script>
